import { useCallback } from "react";
import { Box, Checkbox, Text } from "@mantine/core";
import MaterialPickerSlideRow, { SlideInfo } from "./MaterialPickerSlideRow";

export interface BlockInfo {
  id: string;
  number: string;
  slides?: SlideInfo[];
}

interface MaterialPickerBlockRowProps {
  block: BlockInfo;
  selectedSlideIds: Set<string>;
  isFullySelected: boolean;
  isPartiallySelected: boolean;
  onToggleBlock: (blockId: string) => void;
  onToggleSlide: (slideId: string) => void;
}

export default function MaterialPickerBlockRow({
  block,
  selectedSlideIds,
  isFullySelected,
  isPartiallySelected,
  onToggleBlock,
  onToggleSlide,
}: MaterialPickerBlockRowProps) {
  const handleBlockChange = useCallback(() => {
    onToggleBlock(block.id);
  }, [onToggleBlock, block.id]);

  return (
    <Box ml="lg" mb="xs">
      <Checkbox
        label={`Block ${block.number}`}
        size="sm"
        mb={4}
        checked={isFullySelected}
        indeterminate={isPartiallySelected}
        onChange={handleBlockChange}
      />
      {block.slides?.map((slide) => (
        <MaterialPickerSlideRow
          key={slide.id}
          slide={slide}
          checked={selectedSlideIds.has(slide.id)}
          onToggleSlide={onToggleSlide}
        />
      ))}
      {(!block.slides || block.slides.length === 0) && (
        <Text size="xs" c="dimmed" ml="lg">
          No slides
        </Text>
      )}
    </Box>
  );
}
